const CalendarIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M11.6667 2.33334H2.33333C1.8731 2.33334 1.5 2.70644 1.5 3.16667V11.6667C1.5 12.1269 1.8731 12.5 2.33333 12.5H11.6667C12.1269 12.5 12.5 12.1269 12.5 11.6667V3.16667C12.5 2.70644 12.1269 2.33334 11.6667 2.33334Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 5.83334H12.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.08333 1.5V3.16667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.91667 1.5V3.16667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CalendarIcon;
